import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AcademicAppointment,
} from '../../interfaces/academic-appointment';
import { ApiCollectionResponse } from '../../interfaces/responses/api-response';

/**
 * Calendrier de l'élève connecté : les séances où il est convié nommément
 * et celles des groupes dont il est membre. Les séances annulées en sont exclues,
 * et les notes du professeur ne sont pas exposées.
 *
 * Endpoint: GET /api/students/me/calendar?from&to
 */
@Injectable({ providedIn: 'root' })
export class StudentCalendarService {
  private readonly base = `${environment.BASE_URL}/students/me/calendar`;

  constructor(private http: HttpClient) {}

  /**
   * All active sessions for the current student.
   * @param from ISO date string (e.g. "2026-04-01")
   * @param to   ISO date string (e.g. "2026-04-30")
   */
  myCalendar(
    from?: string,
    to?: string,
  ): Observable<ApiCollectionResponse<AcademicAppointment>> {
    let params = new HttpParams();
    if (from) params = params.set('from', from);
    if (to) params = params.set('to', to);
    return this.http.get<ApiCollectionResponse<AcademicAppointment>>(
      this.base,
      { params },
    );
  }
}
